<div class="my-3">
    <cr-avid-call-status [mssg]="message"
        [@fadeIn]></cr-avid-call-status>
</div>
